import { useEffect, useMemo, useRef } from "react";
import { ProductFruits as ReactProductFruits } from "react-product-fruits";
import { useQuery } from "@tanstack/react-query";
import { isLocal, isUKDevelopment, isUSDevelopment } from "../../services/serviceConfig";
import axiosManager from "../../services/axiosManager";
import { useAuth } from "../../auth";
import { useGetStudents } from "../../hooks/useGetStudents";

const WORKSPACE_CODE_DEV = "alHq4uOKMDJElR6P";
const WORKSPACE_CODE_PROD = "qs822Non0i0EKcAj";
const WORKSPACE_CODE = isLocal || isUKDevelopment || isUSDevelopment ? WORKSPACE_CODE_DEV : WORKSPACE_CODE_PROD;
const LANGUAGE = "en";
const LIFE_CYCLE = "unmount";

const ProductFruits = () => {
    const { isAuthenticated } = useAuth();
    const loginTimeRef = useRef(new Date().toString());

    const { data: userDetails } = useQuery({
        queryKey: ["parent/contacts"],
        queryFn: () => axiosManager.get$("parent/api/Contacts").then((response) => response?.data),
        initialData: {},
        retry: 0,
        enabled: !!isAuthenticated,
    });

    const { students } = useGetStudents();

    useEffect(() => () => {
        window.productFruits?.services?.destroy?.();
    }, []);

    const user = useMemo(() => {
        if (!userDetails?.emailAddress) return null;

        const loginTime = loginTimeRef.current;
        const childrenNames = students?.map((child) => child.fullName)?.filter(Boolean) || [];

        return {
            username: userDetails.emailAddress,
            firstname: userDetails.forename,
            lastname: userDetails.surname,
            props: {
                lastLoggedIn: loginTime,
                children: childrenNames,
                childrenCount: childrenNames.length,
            },
        };
    }, [userDetails, students]);

    if (!user) return null;
    if (isLocal) return null;

    return (
        <ReactProductFruits
            workspaceCode={WORKSPACE_CODE}
            language={LANGUAGE}
            user={user}
            lifeCycle={LIFE_CYCLE}
        />
    );
};

export default ProductFruits;
